import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/apps/website/src/app/(frontend)/[locale]/(public)/artworks/[slug]/components/ArtworkPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PurchaseButton"] */ "/home/vsts/work/1/s/apps/website/src/app/(frontend)/[locale]/(public)/artworks/[slug]/components/purchaseButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartLoadErrorNotification"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/misc/cartLoadErrorNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareLink"] */ "/home/vsts/work/1/s/apps/website/src/modules/general/share/shareLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/home/vsts/work/1/s/apps/website/src/modules/localization/translations.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OImage","SelfGrowingImage"] */ "/home/vsts/work/1/s/apps/website/src/modules/optimization/media/image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSlider"] */ "/home/vsts/work/1/s/apps/website/src/modules/product/imageSlider/imageSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
